import React, { useState, useEffect, useRef } from "react";
import { motion, useAnimation } from "framer-motion";

const FadeInOnScroll = ({ children, delay = 0.01 }) => {
  const ref = useRef(null);
  const controls = useAnimation();
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    const animateWithDelay = () => {
      setTimeout(() => {
        controls.start("visible");
        setHasAnimated(true);
      }, delay * 1000); // convert to ms
    };

    const handleScroll = () => {
      if (!ref.current || hasAnimated) return;

      const rect = ref.current.getBoundingClientRect();
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;

      const threshold = 0.3; // 30% of element height visible
      const triggerPoint = rect.top + rect.height * threshold;

      if (triggerPoint < windowHeight && rect.bottom > 0) {
        animateWithDelay();
        window.removeEventListener("scroll", handleScroll);
      }
    };

    handleScroll(); // Check immediately in case already in view

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [controls, delay, hasAnimated]);

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={controls}
      variants={{
        hidden: { opacity: 0, y: 40 },
        visible: {
          opacity: 1,
          y: 0,
          transition: {
            duration: 0.6,
            ease: [0.25, 0.46, 0.45, 0.94], // smooth ease-out
          },
        },
      }}
    >
      {children}
    </motion.div>
  );
};

export default FadeInOnScroll;
